import MobiluceLayout from "@/layout/MobiluceLayout.vue";
import { P } from "@/config/permissions";

const mobiluceRoutes = {
  path: "/mobiluce",
  name: "Mobiluce",
  component: MobiluceLayout,
  redirect: null,
  hidden: true,
  alwaysShow: false,
  meta: {
    title: "Mobiluce",
    icon: "mdi:phone-check",
    roles: [P.MOBILUCE.BROWSE],
    permissions: [P.MOBILUCE.BROWSE],
    noCache: true,
    breadcrumb: false,
    public: true,
  },
  children: [
    {
      path: "customtab",
      component: () => import("@/views/mobiluce/CustomTab.vue"),
      name: "MobiluceCustomTab",
      meta: {
        title: "Renvois d'appels",
        noCache: true,
        roles: [P.MOBILUCE.BROWSE],
        permissions: [P.MOBILUCE.BROWSE],
        public: true,
      },
      hidden: true,
    },
  ],
};

export default mobiluceRoutes;
